import './ChatItems.css';
import { 
    Box,
    Text
 } 
 from '@chakra-ui/react'

function ChatItem(props) {
    return (
        <ul className="ChatWith">
        <Box bg="#E6E6FA" mL="-100px" my="0" width="90%" maxH="md" p="0"
    

        onClick={() => props.selectChat(props.id)}>
        <li>
        
            {/* Might have to clear floats for this to work*/}
            {/* visit https://css-tricks.com/left-align-and-right-align-text-on-the-same-line/ */}
            <div className='h3'>{props.chatter2}
            </div>
        </li></Box></ul>
    );

}

export default ChatItem;